export var SuccessActionTypes;
(function (SuccessActionTypes) {
    SuccessActionTypes["SHOW_MESSAGE"] = "SHOW_MESSAGE";
    SuccessActionTypes["LINK"] = "LINK";
    SuccessActionTypes["DOWNLOAD_DOCUMENT"] = "DOWNLOAD_DOCUMENT";
    SuccessActionTypes["EXTERNAL_LINK"] = "EXTERNAL_LINK";
})(SuccessActionTypes || (SuccessActionTypes = {}));
export var SecondsToResetDefaults;
(function (SecondsToResetDefaults) {
    SecondsToResetDefaults[SecondsToResetDefaults["MIN"] = 5] = "MIN";
    SecondsToResetDefaults[SecondsToResetDefaults["MAX"] = 10] = "MAX";
    SecondsToResetDefaults[SecondsToResetDefaults["DEFAULT"] = 8] = "DEFAULT";
})(SecondsToResetDefaults || (SecondsToResetDefaults = {}));
//# sourceMappingURL=success-settings.js.map